import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Guide } from '../../structure/types/guide.class';
import { LangService } from '../../services/lang.service';

@Component({
    selector: 'app-guide-card',
    templateUrl: './guide-card.component.html',
    styleUrls: ['./guide-card.component.scss'],
    standalone: false
})
export class GuideCardComponent {
    @Input() guide!: Guide;
    @Input() variant: 'default' | 'resume' | 'completed' = 'default';
    @Output() guideClick = new EventEmitter<Guide>();

    constructor(public lang: LangService) {}

    /** Resource type shown at the top-left — a guide card is always a Guide. */
    get typeLabel(): string {
        return this.lang.data['resources.type_guide'] || 'Guide';
    }

    get categoryTitle(): string | null {
        const first = (this.guide.categories ?? [])[0];
        if (!first) return null;
        const v = first.name ?? null;
        if (typeof v === 'string') return v;
        if (v && typeof v === 'object') return (Object.values(v)[0] as string) ?? null;
        return null;
    }

    get showProgress(): boolean {
        if (this.variant === 'completed') return true;
        // Show the badge for any started guide, including one at 0% (step 0), so it reads
        // as "in progress" in the resume strip.
        return this.guide.status === 'in_progress' || this.guide.status === 'completed';
    }

    onClick() {
        this.guideClick.emit(this.guide);
    }
}
